const getLabel = (value, array) => {
  const target = array.find((item) => item.value === value);

  return target?.label || "-";
};

export default getLabel;
